import UltMeta, { Meta } from "@/meta/UltMeta/index";

// 船务信息服务费状态
class ShipInfoServiceFeeState extends UltMeta {
    UNPAID = new Meta(1, "待支付");
    UN_CONFIRM = new Meta(2, "待确认");
    SUCCESS = new Meta(3, "已支付");
}

export const SHIP_SERVICE_FEE_STATE = new ShipInfoServiceFeeState();

// 船务信息服务费类型
class ShipInfoServiceFeeType extends UltMeta {
    OWNER = new Meta(1, "货主");
    CAPTAIN = new Meta(2, "船主");
}
export const SHIP_SERVICE_FEE_TYPE = new ShipInfoServiceFeeType();

//船务信息服务费 支付方式
class PayType extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const PAY_TYPE = new PayType();
// 导出-业务类型
class BusinessModule extends UltMeta {
    LIST_SHIPPING_INFORMATION_SERVICE_FEES = new Meta(1, "船务信息服务费列表");
}

export const BUSINESS_MODULE = new BusinessModule();
